import apiRequest from 'shared/services/api';
import { ACTION_TYPE } from './actionTypes';

const getFormOptionSuccess = payload => ({
  type: ACTION_TYPE.FORM_OPTION_SUCCESS,
  payload,
});

const getFormOptionFail = payload => ({
  type: ACTION_TYPE.FORM_OPTION_FAIL,
  payload,
});

export const submitClicked = () => ({
  type: ACTION_TYPE.FORM_SUBMIT_CLICK,
});

export const submitInit = () => ({
  type: ACTION_TYPE.FORM_SUBMIT_INIT,
});

/**
 * Get form options from the API
 */
export const getFormOptions = () => async (dispatch, getState) => {
  const { token } = getState().authReducer;

  try {
    const res = await apiRequest.getInitOptions(token);
    dispatch(getFormOptionSuccess(res));
  } catch (err) {
    dispatch(getFormOptionFail(err));
  }
};

// export default getFormOptions;
